import { CertificatesShowcase } from "./Components/CertificatesShowcase";
import { GalleryViewer } from "./Components/GalleryViewer";
import { Helmet } from 'react-helmet-async';

interface GalleryProps{
    certs: string[]
    photos: string[]
}


export const Gallery = ({certs, photos}: GalleryProps) => {
    return (
        <>
            <Helmet>
                <title>Galeria zdjęć i certyfikaty | Biuro rachunkowe Saldo.pl | Cieszyn</title>
                <meta name="description" content="Galeria zdjęć biura rachunkowego Saldo.pl oraz certyfikaty potwierdzające nasze kwalifikacje i doświadczenie. Zobacz nasze biuro i zdobyte wyróżnienia." />
                <meta name="keywords" content="galeria biuro rachunkowe, certyfikaty księgowe, zdjęcia biura, kwalifikacje księgowe, biuro rachunkowe Cieszyn" />
                <link rel="canonical" href="https://podatki-saldo.pl/gallery" />
                <meta property="og:title" content="Galeria i certyfikaty | Biuro rachunkowe Saldo.pl" />
                <meta property="og:description" content="Zobacz zdjęcia naszego biura rachunkowego oraz certyfikaty potwierdzające nasze kwalifikacje i doświadczenie." />
                <meta property="og:url" content="https://podatki-saldo.pl/gallery" />
                <meta property="og:type" content="website" />
            </Helmet>
        <div className="main-content" style={{userSelect: 'none'}}>
            <div className={"certificates"} style={{width: '100vw', height: 'fit-content', background: '#1a1a1a'}}>
            <div style={{
                color: 'white',
                fontWeight: 700,
                fontSize: 32,
                textAlign: 'center',
                width: '80vw',
                margin: '50px auto 30px auto',
                padding: 0,
                background: 'none',
                lineHeight: 1.2,
                position: 'relative',
            }}>
                Certyfikaty
            </div>
            <div style={{ width: '100vw', margin: '0 auto 60px auto'}}>
                <CertificatesShowcase certs={certs}/>
            </div>
            </div>

            <div style={{
                color: '#444',
                fontWeight: 700,
                fontSize: 32,
                textAlign: 'center',
                width: '80vw',
                margin: '40px auto 24px auto',
                padding: 0,
                background: 'none',
                lineHeight: 1.2,
                position: 'relative',
            }}>
                Galeria zdjęć
            </div>
            <div style={{ width: '90vw', margin: '0 auto 60px auto', padding: 5 }}>
                <GalleryViewer photos={photos}/>
            </div>
        </div>
        </>
    )
}
